import React, {useContext, useEffect} from "react";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import PrintInvoice from "../CommonComponents/PrintInvoiceCommonButton";
import PayInvoiceForInvoice from "../CommonComponents/PayInvoiceForInvoice";

export default () => {
    const BtnName = 'GO TO ESTIMATE';
    let PageView = useContext(ViewMangementContext);
    let Record = useContext(RecordsManagementContext);

    const showTermsAndConditions = () => {
        if (PageView.setInvoiceType) {
            PageView.setInvoiceType('INVOICE_3');
        }
        PageView.Set('SHOW BACK PAGE');
    };

    const openEstimate = () => {
        PageView.Set('CLIENT_PORTAL');
    };

    useEffect(() => {
        const handleSticky = () => {
            const header = document.querySelector('.is-sticky');
            if (!header) {
                return;
            }

            if (window.scrollY > 0) {
                header.classList.add('invoice3-sticky-active');
            } else {
                header.classList.remove('invoice3-sticky-active');
            }
        };

        window.addEventListener('scroll', handleSticky);
        handleSticky();

        return () => {
            window.removeEventListener('scroll', handleSticky);
        };
    }, []);

    const showAddendum = (e) => {
        Record.setSelectedAddendum(e.target.value);
        PageView.Set('SHOW ADDENDUM');
    };

    return (
        <div className="invoice3-header-bar">
            <div className="invoice3-header-left">
                <button className='btn btn-dark btn-sm' onClick={openEstimate}>
                    <b>{BtnName}</b>
                </button>
            </div>

            <div className="invoice3-header-actions">
                {Record.IV3_PageDetails.AddendumPresent ?
                    <select className="custom-select invoice3-addendum-select" onChange={showAddendum}>
                        <option defaultValue="Select Addendum">Select Addendum</option>
                        {Object.keys(Record.IV3_PageDetails.AddendumData).map((addendumName, key) => {
                            return (
                                <option key={key + 'addendum_name_3'}
                                        value={Record.IV3_PageDetails.AddendumData[addendumName].id}>
                                    {Record.IV3_PageDetails.AddendumData[addendumName].name}
                                </option>
                            );
                        })}
                    </select> : <></>}

                <PayInvoiceForInvoice/>
                <PrintInvoice/>

                <button className='btn btn-dark btn-sm' onClick={showTermsAndConditions}>
                    <b>SHOW BACK PAGE</b>
                </button>
            </div>
        </div>
    );
};
